import { claimsList, claimsStatus } from './request';
import { unitResource } from './../../insurance/underwritingManage/request';
export default {
  data() {
    const h = this.$createElement;
    return {
      form: {},
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '产品标识'
        },
        dataIndex: 'mark',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'insuranceName',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '承保单位'
        },
        dataIndex: 'unitName',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'unitName'
        },
        ellipsis: true,
        customRender: (text, record) => h("a-tooltip", {
          "attrs": {
            "placement": "topLeft",
            "title": record.unitName
          }
        }, [record.unitName])
      }, {
        slots: {
          title: '理赔方式'
        },
        dataIndex: 'insuranceModeName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        },
        width: 150
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '5',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'sort',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 200
      }],
      unitList: []
    };
  },
  created() {
    unitResource({}).then(res => {
      this.unitList = res;
    });
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      claimsList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    checkedFun(val) {
      if (!this.isAuth('home.insuranceClaimsStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      claimsStatus({
        insuranceId: val.insuranceId,
        status: val.status == 0 ? 1 : 0
      }).then(res => {
        this.$message.success(this.$t('操作成功'));
        this.getDataFun();
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};